import { createContext, ReactNode, useState } from 'react';

const noopFunc = () => new Error('Not implemented');

type ContextType = {
  highlightedCommentId: string | null;
  setHighlightedCommentId: (id: string | null) => void;
};

export const CommentHighlightContext = createContext<ContextType>({
  setHighlightedCommentId: noopFunc,
  highlightedCommentId: null,
});

export const CommentHighlightProvider = (props: { children: ReactNode }) => {
  const [highlightedCommentId, setHighlightedCommentId] = useState<string | null>(null);

  const contextValue = {
    highlightedCommentId,
    setHighlightedCommentId,
  };

  return (
    <CommentHighlightContext.Provider value={contextValue}>
      {props.children}
    </CommentHighlightContext.Provider>
  );
};
